module.exports = __webpack_public_path__ + "static/media/close_thin.93df2cb8.svg";